export default __webpack_public_path__ + "static/media/apply-as-creator-icon.cb48579b.png";